"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _types = require("../actions/types");

var initialState = {
  reviews: [],
  onUpdated: false
}; //although most of the action types returns the same object.
//the api can change, no need to refactor now. 

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var reviews = action.reviews,
      review = action.review;

  switch (action.type) {
    case _types.STORE_REVIEWS:
      return (0, _objectSpread2["default"])({}, state, {
        reviews: (0, _toConsumableArray2["default"])(reviews)
      });

    case _types.UPDATE_REVIEW:
      return (0, _objectSpread2["default"])({}, state, {
        reviews: (0, _toConsumableArray2["default"])(review),
        onUpdated: true
      });

    case _types.UPDATE_REPLY:
      return (0, _objectSpread2["default"])({}, state, {
        reviews: (0, _toConsumableArray2["default"])(review),
        onUpdated: true
      });

    case _types.UPDATED:
      return (0, _objectSpread2["default"])({}, state, {
        onUpdated: false
      });

    case _types.RESET_REVIEWS:
      return (0, _objectSpread2["default"])({}, initialState);

    default:
      return state;
  }
};

exports["default"] = _default;